import React, { useEffect, useState, useContext } from 'react';
import ButtonBack from './images/x.png';
import BasicAnt from './images/BasicAnt.png';
import Info from './images/Icon_Info.png';
import Star from './images/Icon_Star.png';
import Worker from './images/WorkForce.png';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';
import { toast } from 'react-hot-toast';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';
import { doc, updateDoc, increment, getDoc } from 'firebase/firestore';
import { db } from '../components/firebaseConfig'; // Make sure the path is correct
import { SolanaContext } from '../contexts/solanaContext.js';
import useFetchNfts from '../hooks/useFetchNfts.js';

function BasicAntPopup({ onClose, antShopMintInfo }) {
  const { wallet } = useContext(SolanaContext);
  const walletAddress = wallet?.publicKey?.toString();
  const [value, setValue] = useState(0);
  const [price, setPrice] = useState(20000000);
  const { handleBasicANTMint, fetchBlockchainData, fetchBasicBatchInfo } = useSolanaWeb3();
  const [loading, setLoading] = useState(false);
  const { fetchNfts } = useFetchNfts()

  const updateUserNestData = async (userNestId, walletAddress) => {
    // Update the nest's overall PTS and tasksCompleted
    const nestRef = doc(db, 'nests', userNestId);
    await updateDoc(nestRef, {
      PTS: increment(1),
      tasksCompleted: increment(1),
    });
  
    // Update the user's specific information within that nest's users collection
    const userNestRef = doc(db, 'nests', userNestId, 'users', walletAddress);
    await updateDoc(userNestRef, {
      points: increment(1),
      tasksCompleted: increment(1),
      basicAntsBought: increment(1),
    });
  };

  const updateFirestoreAfterPurchase = async (walletAddress) => {
    try {
      const userRef = doc(db, 'users', walletAddress);
      await updateDoc(userRef, {
        boughtAnt: true,
      });
      console.log('Firestore updated successfully for:', walletAddress);
    } catch (error) {
      console.error('Error updating Firestore:', error);
    }
  };

  const basicANTMint = async () => {
    try {
      setLoading(true);
      // const { hash, wait } = await handleBasicANTMint();
      const tx = await handleBasicANTMint();
      await updateFirestoreAfterPurchase(walletAddress);
      const userRef = doc(db, 'users', walletAddress);
    const userSnap = await getDoc(userRef);
    if (userSnap.exists() && userSnap.data().nest) {
      // Update nest data
      await updateUserNestData(userSnap.data().nest, walletAddress);
    }
      await fetchNfts(10)
      toast.success("Successfully Minted");
      // await wait();
      // fetchBlockchainData().finally(() => {
      //   toast.success("Successfully Minted");
      // });
      
    }
    catch (err) {
      console.log("baisc ant mint error:", err)

      if (err.data && String(err.data.message).includes("insufficient funds")) {
        return toast.error("Insufficient funds")
      }
      switch (true) {
        case String(err).includes("User rejected request"):
          toast.error("User rejected request")
          break;
        case String(err).includes("BasicANT: insufficient Tokens"):
          toast.error("Insufficent Tokens for Mint");
          break;
        case String(err).includes("BasicANT: insufficient Matic"):
          toast.error("Insufficent Funds");
          break;
        case String(err).includes("BasicANT: You should approve tokens for minting"):
          toast.error("Insufficient allowance");
          break;
        case String(err).includes("PremiumANT: mint amount exceeds the maximum supply for this batch"):
          toast.error("Mint amount exceeds the maximum supply for this batch")
          break;
        default:
          toast.error("Something went wrong!")
          break;
      }
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (antShopMintInfo) {
      setPrice(antShopMintInfo.price);  // Assuming price is in SOL
    }
  }, [antShopMintInfo]);

  return (
    <div className="popup-container">
      <div className="popup">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} />
        </button>
        <div className="popup-content-left">
          <div className="popupimage-holder"><img id="popup-ant-image" src={BasicAnt}></img></div></div>
        <div className="popup-content-right">
          <div className="popupinfo-holder">
          <h2>Basic Ant</h2>
                <p>Worker ANT: Starting level 1</p>
                <p>Everyone needs to start somewhere. Basic ants are an excellent choice to begin your journey in the kingdom!</p>
            <div className="counter-big"><h1>$20</h1></div>
            <button className="buy-button" onClick={basicANTMint} disabled={loading}><span>{loading ? "Loading..." : "BUY NOW"}</span></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BasicAntPopup;